import { http } from '../../services/http'
import qs from 'querystring'

const state = {
  stocksFilter: {
    limit: 100,
    page: 1,
    search: '',
    warehouse_id: 2
  },
  stocks: {
    current_page: null,
    from: null,
    last_page: null,
    offset: null,
    per_page: null,
    to: null,
    total: null,
    warehouse_id: 2,
    data: []
  }
}

const actions = {
  getStocks(context) {
    let filter = qs.stringify(context.state.stocksFilter)
    http()
      .get(`stocks?${filter}`)
      .then(response => {
        context.commit('updateStocks', response)
      })
    // .catch(error => {
    // 	if(error.response.status >= 400) {
    // 		this.$router.push({name: 'signin'})
    // 	}
    // })
  }
}

const mutations = {
  updateStocks(state, payload) {
    state.stocks = payload.data
  },
  resetStocksPage(state) {
    state.stocksFilter.page = 1
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/stocks.js